<script>
    export default {
        props: {
            initiallyToggled: {
                required: false,
                type: Boolean,
                default: false,
            },
            name: {
                required: false,
                type: String,
                default: '',
            },
            persist: {
                required: false,
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                toggled: false,
            };
        },
        computed: {
            localStorageKey() {
                return `toggler-${this.name}`;
            },
        },
        created() {
            this.validateProps();
            this.toggled = localStorage.getItem(this.localStorageKey) === 'true' || this.initiallyToggled;
        },
        methods: {
            validateProps() {
                // If persists is set, we need to also make sure that the name is set
                // and since validator on props don't allow that we have to do it
                // after the component is created.

                if (this.persist && this.name.length < 1) {
                    throw 'When persisting you need to pass the name property';
                }
            },
            toggle() {
                this.toggled = ! this.toggled;

                if (this.persist) {
                    localStorage.setItem(this.localStorageKey, this.toggled);

                    return;
                }

                localStorage.removeItem(this.localStorageKey);
            },
        },
    };
</script>